/**
 * 胎号的表单验证处理
 * @author zjs
 * @time 2017-09-21
 */
export default {

    methods: {
        /**
         * 验证货品信息
         * @param  {[Array]} arr [货品列表]
         */
        validateProduct (arr) {
            let msg = '' // 提示的信息
            let index = -1 // 记录有问题的行
            for (let i in arr) {
                let row = arr[i]
                let bool = false
                // 判断是否选择货品
                // if (!row.product || !row.product.product_id) {
                //     msg += '"货品"'
                //     bool = true
                // }
                // if (!row.customer || !row.customer.customer_id) {
                //     if (bool) {
                //         msg += '\n、\n'
                //     }
                //     bool = true
                //     msg += '"客户"'
                // }
                if (!row.taihao_no || row.taihao_no.length <= 0) {
                    // if (bool) {
                    //     msg += '\n、\n'
                    // }
                    bool = true
                    msg += '"胎号"'
                }
                if (!row.xiaoshou_time || row.xiaoshou_time.length < 1) {
                    if (bool) {
                        msg += '\n、\n'
                    }
                    msg += '"销售时间"'
                }
                if (msg.length > 0) {
                    index = i
                    break;
                }
            }
            if (index >= 0) {
                msg = '第' + parseInt(parseInt(index) + 1) + '行还未选择\n' + msg
            }
            return msg
        }
    }
}